<!--
 * @Author: gaojingran
 * @Date: 2021-04-12 10:12:51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-12 10:39:24
 * @Description: 面包屑
-->

<style lang="less" scoped>
@active_bg: #e2f0ff;

.neo-breadcrumb {
  display: flex;
  align-items: center;
  .neo-breadcrumb-item {
    &.active {
      .label {
        color: @primary-color;
        background-color: @active_bg;
      }
    }
    .label {
      padding: 2px 5px;
      cursor: pointer;
      font-size: @font_size_2;
      color: @text_color_2;
      border-radius: @border-radius_1;
    }
  }
}
</style>

<template>
  <div class="neo-breadcrumb">
    <div
      class="neo-breadcrumb-item"
      v-for="(item, i) in options"
      :class="value === item.value ? 'active' : ''"
      :key="item.value"
    >
      <span class="label" @click="$emit('input', item.value)">{{ item.label }}</span>
      <a-divider type="vertical" v-if="i < options.length - 1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeoBreadcrumb',
  props: {
    value: {},
    // [{ label: xx, value: xx }]
    options: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
